import React from "react";
import { Form, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useEffect } from "react";
import {
  AnnsModal,
  Col,
  FormDatePicker,
  FormInput,
  FormInputType,
  Icon,
  NoteTypeDropDown,
} from "../../../components/Component";
import { useHistory, useLocation } from "react-router-dom";
import { AppText, showErrorToast, showSuccessToast } from "../../../utils";
import { addCarerNoteAPI, addClientNoteAPI } from "./NoteData";
import { NoteUserType } from "./NoteList";
import { bytesToMegaBytes } from "../../../utils/Utils";
import { fileUploadApi } from "../carers/CarerData";
import { iconsType } from "../../../layout/fileIcon/FileIcon";
// import {addTrustAPI} from "./TrustTableData";

const AddNotes = ({ visible, item, onSaved, onClosed, parents, type }) => {
  const location = useLocation();
  const selected = item?.id;
  const history = useHistory();
  const [noteData, setNoteData] = useState({});
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [removeFileIds, setRemoveFileIds] = useState([]);
  const [isDisable, setIsDisable] = useState(true);
  useEffect(() => {
    if (visible) {
      if (item) {
        setNoteData((prevState) => ({
          ...prevState,
          id: item?.id,
          subject: item?.subject,
          outcome: item?.outcome,
          noteDate: new Date(item?.noteDate),
          lessionLearn: item?.lessionLearn,
          description: item?.description,
          noteType: item?.noteType,
        }));
        if (item?.fileData) {
          const filesWithOldFlag = item.fileData.map((file) => {
            if (file?.clientNoteFile_id || file?.carerNoteFile_id) {
              file.isOldFile = true;
            }
            return file;
          });
          setUploadedFiles(filesWithOldFlag);
        }
      } else {
        setNoteData({
          subject: "",
          outcome: "",
          noteDate: null,
          lessionLearn: "",
          description: "",
          noteType: null,
        });
        setUploadedFiles([]);
        setRemoveFileIds([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, item]);
  useEffect(() => {
    return () => {
      // Cleanup function to cancel any ongoing tasks/subscriptions
      setLoading(false);
    };
  }, []);
  useEffect(() => {
    const hasEmptyFields = noteData.subject === "" || noteData.noteType === "" || noteData.noteDate === null;
    const hasErrors = noteData.isSubjectError;
    setIsDisable(hasEmptyFields || hasErrors);
  }, [noteData]);
  const close = () => {
    onClosed();
    setLoading(false);
    setNoteData({});
    setUploadedFiles([]);
    setRemoveFileIds([]);
  };
  const onFormSubmit = () => {
    if (!parents) return;
    if (isDisable) return;
    // Prevent multiple API calls if already loading
    if (loading) {
      return;
    }
    setLoading(true);
    if (type === NoteUserType.hospital) {
      const formData = {
        noteData: {
          ...noteData,
        },
        uploadedFiles: [...uploadedFiles],
        removeFileIds: [...removeFileIds],
      };
      addClientNoteAPI(
        formData,
        parents?.map((item) => item.id),
        (_, error) => {
          if (error === null) {
            let text = "Client note" + (item ? AppText.EditedSuccessfully : AppText.AddedSuccessfully);
            showSuccessToast(text);
            setLoading(false);
            // history.goBack();
            onSaved();
            close(); // Go back to the previous tab
          } else {
            showErrorToast(error.message);
            setLoading(false);
          }
        },
      );
    } else if (type === NoteUserType.carer) {
      const formData = {
        noteData: {
          ...noteData,
        },
        uploadedFiles: [...uploadedFiles],
        removeFileIds: [...removeFileIds],
      };
      addCarerNoteAPI(
        formData,
        parents?.map((item) => item.id),
        (_, error) => {
          if (error === null) {
            let text = "Carer note" + (item ? AppText.EditedSuccessfully : AppText.AddedSuccessfully);
            showSuccessToast(text);
            setLoading(false);
            onSaved();
            close(); // Go back to the previous tab
          } else {
            showErrorToast(error.message);
            setLoading(false);
          }
        },
      );
    }
  };
  const uploadFile = (file, index) => {
    let noteType = "";
    if (type === NoteUserType.carer) {
      noteType = "CARER_NOTE";
    } else if (type === NoteUserType.hospital) {
      noteType = "CLIENT_NOTE";
    } else {
      console.error("Invalid type. No note type assigned.");
      return;
    }
    fileUploadApi(file, noteType, (data, error) => {
      const updatedfiles = [...uploadedFiles];
      if (error === null) {
        file.id = data.id;
        file.isLoading = false;
        file.fileUrl = data.fileUrl;
        updatedfiles[index] = file;
        setUploadedFiles(updatedfiles);
      } else {
        updatedfiles.splice(index, 1);
        setUploadedFiles(updatedfiles);
        showErrorToast(error.message.length > 0 ? error.message : AppText.connectError);
      }
    });
  };
  const handleFileSelect = (file, rootIndex) => {
    if (bytesToMegaBytes(file.size) > 100) {
      showErrorToast(AppText.maxFileSizeError);
    } else {
      const fileDetails = file;
      fileDetails.isLoading = true;
      fileDetails.isError = false;
      fileDetails.id = null;
      fileDetails.isOldFile = false;
      const updatedfiles = [...uploadedFiles];
      updatedfiles.push(fileDetails);
      setUploadedFiles(updatedfiles);
      uploadFile(fileDetails, updatedfiles.length - 1);
    }
  };
  const handleFileRemove = (ind) => {
    const updatedfiles = [...uploadedFiles];
    removeFileIds.push(updatedfiles[ind].clientNoteFile_id || updatedfiles[ind].carerNoteFile_id);
    updatedfiles.splice(ind, 1);
    setUploadedFiles(updatedfiles);
  };
  const openFileInNewTab = (file) => {
    if (file) {
      window.open(file?.fileUrl, "_blank");
    }
  };
  const { errors, register, handleSubmit } = useForm();
  return (
    <>
      <AnnsModal
        size={"lg"}
        isOpen={visible}
        toggle={() => onClosed()}
        title={item ? "Edit Note" : "Add Note"}
        onClick={() => onFormSubmit()}
        loading={loading}
        disabled={isDisable}
      >
        <Form
          className="row gy-4 form-validation"
          onSubmit={(e) => {
            e.preventDefault();
            // Prevent form submission if already loading
            if (!loading) {
              handleSubmit(onFormSubmit)(e);
            }
          }}
        >
          <Col md="12">
            <div className="form-group">
              <div className="form-control-wrap">
                <FormInput
                  label={"Subject"}
                  type={FormInputType.default}
                  value={noteData?.subject ?? ""}
                  placeholder={"Enter subject"}
                  onError={(isError) => {
                    setNoteData((prev) => ({
                      ...prev,
                      isSubjectError: isError,
                    }));
                  }}
                  onTextChange={(subject) => {
                    setNoteData((prev) => ({
                      ...prev,
                      subject: subject,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label"> Note Type</label>
              <div className="form-control-wrap">
                <NoteTypeDropDown
                  placeholder={"Select noteType"}
                  value={noteData?.noteType}
                  onSelect={(noteType) => {
                    setNoteData((prev) => ({
                      ...prev,
                      noteType: noteType,
                    }));
                  }}
                  selectedId={noteData?.noteType?.id}
                />
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label">Note Date</label>
              <div className="form-control-wrap">
                <FormDatePicker
                  selected={noteData?.noteDate ?? null}
                  onChange={(noteDate) => {
                    setNoteData((prev) => ({
                      ...prev,
                      noteDate: noteDate,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md="12">
            <div className="form-group">
              <label className="form-label">Description</label>
              <div className="form-control-wrap">
                <textarea
                  className="form-control"
                  placeholder="Description"
                  value={noteData?.description ?? ""}
                  onChange={(e) => {
                    setNoteData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md="12">
            <div className="form-group">
              <label className="form-label">Outcome</label>
              <div className="form-control-wrap">
                <textarea
                  className="form-control"
                  placeholder="Outcome"
                  value={noteData?.outcome ?? ""}
                  onChange={(e) => {
                    setNoteData((prev) => ({
                      ...prev,
                      outcome: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md="12">
            <div className="form-group">
              <label className="form-label">Lesson Learn</label>
              <div className="form-control-wrap">
                <textarea
                  className="form-control"
                  placeholder="Lesson Learn"
                  value={noteData?.lessionLearn ?? ""}
                  onChange={(e) => {
                    setNoteData((prev) => ({
                      ...prev,
                      lessionLearn: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col className="col-12">
            <div className="form-group mb-0">
              <label htmlFor="files">
                <Icon name="clip" className="fs-6 text-primary" />
                <span className="text-primary">Attach document</span>
              </label>
              <input
                type="file"
                name="files"
                accept=".pdf,.png,.jpg,.jpeg,.webp,.heic"
                className="form-control"
                id={"files"}
                style={{
                  display: "none",
                }}
                onChange={(e) => {
                  let temp = Array.prototype.slice.call(e.target.files);
                  if (temp.length > 0) {
                    handleFileSelect(temp[0]);
                  }
                  e.target.value = "";
                }}
              />
            </div>

            {uploadedFiles?.length > 0 &&
              uploadedFiles?.map((file, ind) => {
                return (
                  <React.Fragment key={`file-${ind}`}>
                    <div className="nk-upload-item">
                      <div className="nk-upload-icon">
                        {file?.isOldFile ? (
                          <>{iconsType[file?.fileMimetype] ? iconsType[file?.fileMimetype] : iconsType["others"]}</>
                        ) : (
                          <>{iconsType[file?.type] ? iconsType[file?.type] : iconsType["others"]}</>
                        )}
                      </div>
                      <div className="nk-upload-info">
                        <div className="nk-upload-title">
                          <span
                            className="title"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => openFileInNewTab(file)}
                          >
                            {file?.isOldFile ? file?.fileName : (file?.name ?? "")}
                          </span>
                        </div>
                      </div>
                      <div className="nk-upload-action">
                        <a
                          href="#delete"
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                          className="btn btn-icon btn-trigger round-40  d-flex justify-content-center align-items-center"
                        >
                          {file?.isLoading ? (
                            <Spinner size="sm" color="dark" />
                          ) : (
                            <span onClick={() => handleFileRemove(ind)}>
                              <Icon name="trash"></Icon>
                            </span>
                          )}
                        </a>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
          </Col>
        </Form>
      </AnnsModal>
    </>
  );
};
export default AddNotes;
